<template>
  <b-skeleton-wrapper :loading="isLoading">
    <template #loading>
      <div class="row gy-5">
        <div class="col-12">
          <div class="row gy-3">
            <div class="col-12">
              <b-skeleton
                no-aspect
                animation="fade"
                width="50%"
                class="light"
              ></b-skeleton>
            </div>
            <div class="col-12">
              <div class="row gx-3 gy-3">
                <div class="col-12 col-md-6">
                  <b-skeleton
                    no-aspect
                    animation="fade"
                    height="40px"
                    class="light"
                  ></b-skeleton>
                </div>
                <div class="col-12 col-md-6">
                  <b-skeleton
                    no-aspect
                    animation="fade"
                    height="40px"
                    class="light"
                  ></b-skeleton>
                </div>
                <div class="col-12 col-md-6">
                  <b-skeleton
                    no-aspect
                    animation="fade"
                    height="40px"
                    class="light"
                  ></b-skeleton>
                </div>
                <div class="col-12 col-md-6">
                  <b-skeleton
                    no-aspect
                    animation="fade"
                    height="40px"
                    class="light"
                  ></b-skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row gy-3">
            <div class="col-12">
              <b-skeleton
                no-aspect
                animation="fade"
                width="50%"
                class="light"
              ></b-skeleton>
            </div>
            <div class="col-12">
              <div class="row gx-3 gy-3">
                <div class="col-12 col-md-6">
                  <b-skeleton
                    no-aspect
                    animation="fade"
                    height="40px"
                    class="light"
                  ></b-skeleton>
                </div>
                <div class="col-12 col-md-6">
                  <b-skeleton
                    no-aspect
                    animation="fade"
                    height="40px"
                    class="light"
                  ></b-skeleton>
                </div>
                <div class="col-12 col-md-6">
                  <b-skeleton
                    no-aspect
                    animation="fade"
                    height="40px"
                    class="light"
                  ></b-skeleton>
                </div>
                <div class="col-12 col-md-6">
                  <b-skeleton
                    no-aspect
                    animation="fade"
                    height="40px"
                    class="light"
                  ></b-skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <div class="row gy-5 text-start">
      <div class="col-12">
        <div class="row gy-3">
          <div class="col-12">
            <h1
              class="fs-18 w-bold mb-0"
              :class="{'darks' : color !== 'dark'}"
            >
              Datos personales
            </h1>
          </div>
          <div class="col-12">
            <div class="c-form c-form--ghost">
              <div class="row gx-3 gy-3">
                <div class="col-12 col-md-6">
                  <div
                    class="c-form-group"
                    :class="{'c-form-group--error' : $v.profile.first_name.$error}"
                  >
                    <label class="w-sbold fs-14 mb-1">Nombres*</label>
                    <input
                      v-model.trim="$v.profile.first_name.$model"
                      class="c-form__input d-block w-100 tiny"
                      type="text"
                      :disabled="profile.verifiedName"
                    />
                    <span
                      v-if="!$v.profile.first_name.required"
                      class="c-form__error"
                    >
                      Nombres requeridos
                    </span>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div
                    class="c-form-group"
                    :class="{'c-form-group--error' : $v.profile.last_name.$error}"
                  >
                    <label class="w-sbold fs-14 mb-1">Apellidos*</label>
                    <input
                      v-model.trim="$v.profile.last_name.$model"
                      class="c-form__input d-block w-100 tiny"
                      type="text"
                      :disabled="profile.verifiedName"
                    />
                    <span
                      v-if="!$v.profile.last_name.required"
                      class="c-form__error"
                    >
                      Apellidos requeridos
                    </span>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <label class="w-sbold fs-14 mb-1">Usuario</label>
                  <input
                    v-model="userData.username"
                    class="c-form__input d-block w-100 tiny"
                    type="text"
                    disabled
                  />
                </div>
                <div class="col-12 col-md-6">
                  <label class="w-sbold fs-14 mb-1">Correo electrónico</label>
                  <input
                    v-model="userData.email"
                    class="c-form__input d-block w-100 tiny"
                    type="text"
                    disabled
                  />
                </div>
                <div class="col-12 col-md-6">
                  <div
                    class="c-form-group"
                    :class="{'c-form-group--error' : $v.profile.mobile.$error}"
                  >
                    <label class="w-sbold fs-14 mb-1">Número de teléfono / Whatsapp*</label>
                    <VuePhoneNumberInput
                      v-model="$v.profile.mobile.$model"
                      class="c-form__phone tiny"
                      @update="updatePhoneDetails"
                      :default-country-code="profile.country_code"
                      :no-example="true"
                      :translations="translations"
                    />
                    <span
                      v-if="!$v.profile.mobile.required"
                      class="c-form__error"
                    >
                      Número de teléfono requerido
                    </span>
                    <span
                      v-else-if="!$v.profile.mobile.isValid"
                      class="c-form__error"
                    >
                      Número de teléfono incorrecto
                    </span>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="d-flex flex-column">
                    <label class="w-sbold fs-14 mb-1">Fecha de Nacimiento</label>
                    <input
                      v-model="profile.date_born"
                      class="c-form__input d-block w-100 tiny flex-grow-1"
                      type="date"
                    />
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <label class="w-sbold fs-14 mb-1">Género</label>
                  <select
                    v-model="profile.genre"
                    class="c-form__select d-block w-100 tiny"
                  >
                    <option value="" selected disabled>Seleccione</option>
                    <option value="Masculino">Masculino</option>
                    <option value="Femenino">Femenino</option>
                    <option value="Otro">Otro</option>
                  </select>
                </div>
                <div class="col-12 col-md-6">
                  <div
                    class="c-form-group"
                    :class="{'c-form-group--error' : $v.profile.dni.$error}"
                  >
                    <label class="w-sbold fs-14 mb-1">{{userIDLabel}} *</label>
                    <input
                      v-model.trim="$v.profile.dni.$model"
                      class="c-form__input d-block w-100 tiny"
                      type="text"
                    />
                    <span
                      v-if="!$v.profile.dni.minLength"
                      class="c-form__error"
                    >
                      {{userIDLabel}} inválido (minimo 5 digitos)
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="row gy-3">
          <div class="col-12">
            <h1
              class="fs-18 w-bold mb-0"
              :class="{'darks' : color !== 'dark'}"
            >
              Datos Académicos
            </h1>
          </div>
          <div class="col-12">
            <div class="c-form c-form--ghost">
              <div class="row gx-3 gy-3">
                <div class="col-12 col-md-6">
                  <label class="w-sbold fs-14 mb-1">Campo de estudios</label>
                  <select
                    v-model="profile.field_study"
                    class="c-form__select d-block w-100 tiny"
                  >
                    <option value="" selected disabled>Seleccione</option>
                    <option value="Arquitectura">Arquitectura</option>
                    <option value="Ingeniería Civil">Ingeniería Civil</option>
                    <option value="Diseño de Interiores">Diseño de Interiores</option>
                    <option value="Otro">Otro</option>
                  </select>
                </div>
                <div class="col-12 col-md-6">
                  <label class="w-sbold fs-14 mb-1">Nivel de Formación</label>
                  <select
                    v-model="profile.level_education"
                    class="c-form__select d-block w-100 tiny"
                  >
                    <option value="" selected disabled>Seleccione</option>
                    <option value="Estudiante (1er, 2do año)">Estudiante (1er, 2do año)</option>
                    <option value="Estudiante (3er, 4to, 5to año)">
                      Estudiante (3er, 4to, 5to año)
                    </option>
                    <option value="Bachiller/Egresado">
                      Bachiller/Egresado
                    </option>
                    <option value="Profesional Titulado">
                      Profesional Titulado
                    </option>
                    <option value="Estudiante de Maestría/Doctorado">
                      Estudiante de Maestría/Doctorado
                    </option>
                    <option value="Magister/Doctor">
                      Magister/Doctor
                    </option>
                    <option value="Otro">
                      Otro
                    </option>
                  </select>
                </div>
                <div class="col-12">
                  <label class="w-sbold fs-14 mb-1">Universidad o centro de Estudios</label>
                  <input
                    v-model="profile.university"
                    class="c-form__input d-block w-100 tiny"
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="variant === 'full'" class="col-12">
        <div class="row gy-3">
          <div class="col-12">
            <h1
              class="fs-18 w-bold mb-0"
              :class="{'darks' : color !== 'dark'}"
            >
              Redes Sociales
            </h1>
          </div>
          <div class="col-12">
            <div class="c-form c-form--ghost">
              <div class="row gx-3 gy-3">
                <div class="col-12 col-md-6">
                  <label class="w-sbold fs-14 mb-1">Facebook</label>
                  <input
                    v-model="profile.facebook"
                    class="c-form__input d-block w-100 tiny"
                    type="text"
                    placeholder="Ej. https://facebook.com/usuario"
                  />
                </div>
                <div class="col-12 col-md-6">
                  <label class="w-sbold fs-14 mb-1">Instagram</label>
                  <input
                    v-model="profile.instagram"
                    class="c-form__input d-block w-100 tiny"
                    type="text"
                    placeholder="Ej. https://instagram.com/usuario"
                  />
                </div>
                <div class="col-12 col-md-6">
                  <label class="w-sbold fs-14 mb-1">Linkedin</label>
                  <input
                    v-model="profile.linkedin"
                    class="c-form__input d-block w-100 tiny"
                    type="text"
                    placeholder="Ej. https://linkedin.com/usuario"
                  />
                </div>
                <div class="col-12 col-md-6">
                  <label class="w-sbold fs-14 mb-1">Twitter</label>
                  <input
                    v-model="profile.twitter"
                    class="c-form__input d-block w-100 tiny"
                    type="text"
                    placeholder="Ej. https://twitter.com/usuario"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <slot name="actions"></slot>
      </div>
    </div>
  </b-skeleton-wrapper>
</template>

<script>
import { scroller } from 'vue-scrollto/src/scrollTo';
import VuePhoneNumberInput from 'vue-phone-number-input';
import { mapState } from 'vuex';
import {
  required,
  minLength,
} from 'vuelidate/lib/validators';

export default {
  props: {
    variant: String,
    color: String,
    isUpdating: Boolean,
    isChanged: Boolean,
    handleSuccess: Function,
    handleError: Function,
    handleInvalid: Function,
  },
  data() {
    return {
      scroll: scroller(),

      profile: {
        verifiedName: 0,

        first_name: '',
        last_name: '',
        mobile: '',
        country_code: '',
        date_born: '',
        genre: '',
        dni: '',

        field_study: '',
        level_education: '',
        university: '',

        facebook: '',
        instagram: '',
        linkedin: '',
        twitter: '',
      },
      isValidPhone: true,
      country_code: 'pe',
      translations: {
        countrySelectorLabel: 'País',
        phoneNumberLabel: 'ej. 944444444',
      },

      isLoading: true,
      updatedKeys: [],

      statusMessage: null,
    };
  },
  validations: {
    profile: {
      first_name: {
        required,
      },
      last_name: {
        required,
      },
      dni: {
        required,
        minLength: minLength(5),
      },
      mobile: {
        required,
        isValid: function isValidMobile() {
          return this.isValidPhone;
        },
      },
    },
  },
  components: {
    VuePhoneNumberInput,
  },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),

    userIDLabel() {
      let label = 'DNI';

      switch (this.country_code) {
        case 'bo':
        case 'cl':
        case 'cr':
        case 'ec':
        case 'ni':
        case 'uy':
        case 've':
        case 'py':
          label = 'CI';
          break;

        case 'co':
          label = 'CC';
          break;

        case 'sv':
          label = 'DUI';
          break;

        case 'gt':
          label = 'DPI';
          break;

        case 'hn':
          label = 'TDI';
          break;

        case 'mx':
          label = 'CURP';
          break;

        case 'pa':
          label = 'CIP';
          break;

        case 'do':
          label = 'CIE';
          break;

        case 'pr':
          label = 'Licencia de Conducir o  Número de Seguro Social';
          break;

        default:
          label = 'DNI';
          break;
      }

      return label;
    },
  },
  watch: {
    userData() {
      this.getGeneralData();
      this.getProfileData();
    },
    updatedKeys() {
      this.$emit('update:isChanged', Boolean(this.updatedKeys.length));
    },

    'profile.first_name': function updateFirstName(value, oldValue) {
      if (value !== oldValue && !this.updatedKeys.includes('first_name')) {
        this.updatedKeys.push('first_name');
      }
    },
    'profile.last_name': function updateFirstName(value, oldValue) {
      if (value !== oldValue && !this.updatedKeys.includes('last_name')) {
        this.updatedKeys.push('last_name');
      }
    },
    'profile.mobile': function updateFirstName(value, oldValue) {
      if (value !== oldValue && !this.updatedKeys.includes('mobile')) {
        this.updatedKeys.push('mobile');
      }
    },
    'profile.country_code': function updateFirstName(value, oldValue) {
      if (value !== oldValue && !this.updatedKeys.includes('country_code')) {
        this.updatedKeys.push('country_code');
      }
    },
    'profile.date_born': function updateFirstName(value, oldValue) {
      if (value !== oldValue && !this.updatedKeys.includes('date_born')) {
        this.updatedKeys.push('date_born');
      }
    },
    'profile.genre': function updateFirstName(value, oldValue) {
      if (value !== oldValue && !this.updatedKeys.includes('genre')) {
        this.updatedKeys.push('genre');
      }
    },
    'profile.dni': function updateFirstName(value, oldValue) {
      if (value !== oldValue && !this.updatedKeys.includes('dni')) {
        this.updatedKeys.push('dni');
      }
    },

    'profile.field_study': function updateFirstName(value, oldValue) {
      if (value !== oldValue && !this.updatedKeys.includes('field_study')) {
        this.updatedKeys.push('field_study');
      }
    },
    'profile.level_education': function updateFirstName(value, oldValue) {
      if (value !== oldValue && !this.updatedKeys.includes('level_education')) {
        this.updatedKeys.push('level_education');
      }
    },
    'profile.university': function updateFirstName(value, oldValue) {
      if (value !== oldValue && !this.updatedKeys.includes('university')) {
        this.updatedKeys.push('university');
      }
    },

    'profile.facebook': function updateFirstName(value, oldValue) {
      if (value !== oldValue && !this.updatedKeys.includes('facebook')) {
        this.updatedKeys.push('facebook');
      }
    },
    'profile.linkedin': function updateFirstName(value, oldValue) {
      if (value !== oldValue && !this.updatedKeys.includes('linkedin')) {
        this.updatedKeys.push('linkedin');
      }
    },
    'profile.instagram': function updateFirstName(value, oldValue) {
      if (value !== oldValue && !this.updatedKeys.includes('instagram')) {
        this.updatedKeys.push('instagram');
      }
    },
    'profile.twitter': function updateFirstName(value, oldValue) {
      if (value !== oldValue && !this.updatedKeys.includes('twitter')) {
        this.updatedKeys.push('twitter');
      }
    },
  },
  mounted() {
    if (this.userData && this.userData.id) {
      this.getGeneralData();
      this.getProfileData();
    }
  },
  methods: {
    updatePhoneDetails(e) {
      this.isValidPhone = e.isValid;

      this.profile.country_code = e.countryCode;
    },

    getGeneralData() {
      fetch(`${window.arcux.api}/pages/data`)
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.country_code = response.data.country_code;
          }
        })
        .catch(() => {});
    },
    getProfileData() {
      fetch(`${window.arcux.api}/users/${this.userData.id}/profile`, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.profile = {
              ...response.data,
              verifiedName: Number(response.data.verified_name),
              country_code: response.data.country_code.toUpperCase(),
            };

            setTimeout(() => {
              this.updatedKeys = [];
            }, 200);
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false;
        });
    },

    updateProfile() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const formData = new FormData();

        this.$emit('update:isUpdating', true);

        this.updatedKeys.forEach((key) => {
          formData.append(key, this.profile[key]);
        });

        fetch(`${window.arcux.api}/users/${this.userData.id}/profile/update`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${window.arcux.token}`,
          },
          body: formData,
        })
          .then((res) => {
            if (res.status === 200 || res.status < 300) {
              return res.json();
            }

            throw res;
          })
          .then((response) => {
            if (response.status) {
              this.handleSuccess();
            } else {
              this.handleError();
            }
          })
          .catch(() => {
            this.handleError();
          })
          .finally(() => {
            this.$emit('update:isUpdating', false);
          });
      } else if (this.handleInvalid) {
        this.handleInvalid();
      }
    },
  },
};
</script>
